export default "__VITE_ASSET__DbBpjLIG__"